// Redimensiona uma imagem no navegador (PNG preserva transparência) e devolve data URL dentro do limite.
export const comprimirImagem = (file, maxW = 900, limite = 380000) => new Promise((resolve, reject) => {
  const img = new Image(); const url = URL.createObjectURL(file);
  img.onload = () => {
    const k = Math.min(1, maxW / img.width); const cv = document.createElement("canvas");
    cv.width = Math.round(img.width * k); cv.height = Math.round(img.height * k);
    cv.getContext("2d").drawImage(img, 0, 0, cv.width, cv.height); URL.revokeObjectURL(url);
    const png = file.type === "image/png"; let out = cv.toDataURL(png ? "image/png" : "image/jpeg", 0.85);
    if (out.length > limite) out = cv.toDataURL("image/jpeg", 0.7);
    out.length > limite ? reject(new Error("Imagem muito grande mesmo após compressão")) : resolve(out);
  };
  img.onerror = () => reject(new Error("Arquivo de imagem inválido")); img.src = url;
});
